/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORTS (theme) --------------- ++++++++++ */
export const theme = {
	
	// <<<<< _____ COLORS _____ >>>>> //
	color: {
		// ----- main ----- //
		// blues
		primary: { 
			dark: 	{ swatch: '#0D5D99', contrast: '#ffffff' }, 
			medium: { swatch: '#1494F4', contrast: '#ffffff' }, 
			light: 	{ swatch: '#D0EAFD', contrast: '#0D5D99' }
		},
		// greens
		secondary: { 
			dark: 	{ swatch: '#5F9E19', contrast: '#ffffff' },
			medium: { swatch: '#7ED321', contrast: '#ffffff' },
			light: 	{ swatch: '#C3EB97', contrast: '#5F9E19' },
			xlight: { swatch: '#f4fced', contrast: '#5F9E19' }
		},
		// dark blues
		supporting: { 
			dark: 	{ swatch: '#062B75', contrast: '#ffffff' },
			medium: { swatch: '#062B75', contrast: '#ffffff' },
			light: 	{ swatch: '#FAFBFC', contrast: '#062B75' },
			xlight: { swatch: '#8295ba', contrast: '#8295ba'}
		}, 

		// ----- complimentary ----- //
		// oranges
		accent: { 
			dark: 	{ swatch: '#E67411', contrast: '#ffffff' },
			medium: { swatch: '#FFAE22', contrast: '#ffffff' },
			light: 	{ swatch: '#FFE0AA', contrast: '#E67411' }
		},
		// purples
		compliment: { 
			dark: 	{ swatch: '#5639BF', contrast: '#ffffff' },
			medium: { swatch: '#734CFF', contrast: '#ffffff' },
			light: 	{ swatch: '#D0C3FF', contrast: '#5639BF' }
		},
		// reds
		attention: { 
			dark: 	{ swatch: '#DF1D1D', contrast: '#ffffff' },
			medium: { swatch: '#FFD1D1', contrast: '#DF1D1D' },
			light: 	{ swatch: '#FF8A80', contrast: '#DF1D1D' }
		}, 

		// ----- system ----- //
		// greys
		neutral: { 
			dark: 	{ swatch: '#9E9E9E', contrast: '#ffffff' },
			medium: { swatch: '#aaaaaa', contrast: '#ffffff' },
			light:  { swatch: '#EDEDED', contrast: '#ffffff' },
			xlight: { swatch: '#F5F5F5', contrast: '#ffffff' }
		},
		// whites
		light: { 
			dark: 	{ swatch: '#fcfcfc', contrast: '#000000' },
			medium: { swatch: '#fccfcf', contrast: '#000000' },
			light: 	{ swatch: '#ffffff', contrast: '#000000' }
		},
		// blacks
		dark: { 
			dark: 	{ swatch: '#000000', contrast: '#000000' },
			medium: { swatch: '#333333', contrast: '#000000' },
			light: 	{ swatch: '#555555', contrast: '#000000' }
		},
		// greys
		grey: {
			dark: 	{ swatch: '#555555', contrast: '#ffffff' },
			medium: { swatch: '#dddddd', contrast: '#000000' },
			light: 	{ swatch: '#eeeeee', contrast: '#000000' }
		},
		// system
		system: {
			dark: 	{ swatch: '#FAFBFC', contrast: '#1494F4' },
			medium: { swatch: '#FAFBFC', contrast: '#1494F4' },
			light: 	{ swatch: '#FAFBFC', contrast: '#1494F4' }
		},

		// ----- content types ----- //
		quiz: { 
			medium: { swatch: '#FFAE22', contrast: '#ffffff' }
		},
		poll: { 
			medium: { swatch: '#734CFF', contrast: '#ffffff' }
		},
		story: {
			medium: { swatch: '#00af95', contrast: '#ffffff' }
		}
	},

	// <<<<< _____ TYPOGRAPHY _____ >>>>> //
	typography: {
		// fonts
		font: 'WorkSans-Medium, Verdana, Arial, sans-serif',
		// weights
		weight: { regular: '400', medium: '500', semibold: '600' },
		// sizes
		size: {
			xxxlarge: 	{ fontSize: pxToEm(48), lineHeight: '1.5' },
			xxlarge: 	{ fontSize: pxToEm(42), lineHeight: '1.5' },
			xlarge: 	{ fontSize: pxToEm(36), lineHeight: '1.5' },

			large: 		{ fontSize: pxToEm(32), lineHeight: '1.5' },
			medium: 	{ fontSize: pxToEm(24), lineHeight: '1.5' },
			small: 		{ fontSize: pxToEm(16), lineHeight: '1.5' },

			xsmall: 	{ fontSize: pxToEm(14), lineHeight: '1.5' },
			xxsmall: 	{ fontSize: pxToEm(12), lineHeight: '1.5' },
			xxxsmall: 	{ fontSize: pxToEm(10), lineHeight: '1.5' }
		}
	},

	// <<<<< _____ SPACING _____ >>>>> //
	spacing: {
		sides: '5%' //pxToEm(80)
	},

	// <<<<< _____ BOX SHADOW _____ >>>>> //
	boxShadow: {
		smallTop: replacePXinStringWithEM(`1px 0px 6px 0px rgba(0,0,0,0.8)`),
		small: replacePXinStringWithEM(`0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)`),
		highlight: replacePXinStringWithEM(`0px 0px 24px 0px rgba(45,117,41,1)`),
		highlightCard: replacePXinStringWithEM(`0px 0px 14px 0px #ccc`),
		bar: 'rgba(6, 43, 117, 0)',
		inset: `inset 0 ${pxToEm(3)} ${pxToEm(4)} 0 #ECF0F7`
	},

	// <<<<< _____ MODALs _____ >>>>> //
	modal: {
		form: {
			display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'space-between',
	        '& .grid':{
	            width: '100%',
	            '& .gridset':{
	                width: '50%',
	                marginRight: pxToEm(16),
	                '& .field':{
	                    width: '100%'
	                }
	            }
	        },
	        '& .name-ctas':{
	            '& button':{
	                width:pxToEm(190),
	                margin: pxToEm(9)
	            }
	        }
		}
	},

	// <<<<< _____ ANIMATION _____ >>>>> //
	animation: {
		general: (el) => `${el} .2s linear 0s`
	}
};
